<template>
  <ProductDetailPageComponent
    v-bind="productDetailPageComponentProps"
    @unauthenticatedProductClick="unauthenticatedProductClick"
    @addToCart="addToCart($event)"
  />
</template>

<script>
import ProductDetailPageComponent from '@/components/Webshop/ProductDetailPage'
import productPageMixin from '@/mixins/productPage'

export default {
  name: 'ProductDetailPage',
  layout: 'webshop',
  components: { ProductDetailPageComponent },
  mixins: [productPageMixin]
}
</script>
